module.exports = __webpack_public_path__ + "029de9cb5b1ce82f3405b3c7fbcc5f.png";